import {
  GET_RENTALS,
  GET_RENTALS_ADMIN,
  GET_RENTALS_SALES,
  VALIDATE_RENTAL_SUCCESS,
  VALIDATE_RENTAL_ERROR,
  UPDATE_RENTAL_STATUS_SUCCESS,
  UPDATE_RENTAL_STATUS_ERROR,
  CREATE_DM_RENTALS_SUCCESS,
  CREATE_DM_RENTALS_ERROR,
} from "../../actions/rentals/rentals";

const initialState = {
  rentals: [],
  loading: false,
  error: null,
};

export default function rentals(state = initialState, action) {
  switch (action.type) {
    case GET_RENTALS:
      return {
        ...state,
        rentals: action.rentals,
        loading: false,
        error: null,
      };
    case GET_RENTALS_ADMIN:
      return {
        ...state,
        rentals: action.rentals,
        loading: false,
        error: null,
      };
    case GET_RENTALS_SALES:
      return {
        ...state,
        rentals: action.rentals,
        loading: false,
        error: null,
      };
    case VALIDATE_RENTAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case VALIDATE_RENTAL_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case UPDATE_RENTAL_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case UPDATE_RENTAL_STATUS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case CREATE_DM_RENTALS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case CREATE_DM_RENTALS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}
